<template>
  <div class="flex flex-col items-center px-4 pt-2 pb-8 h-full justify-between">
    <div class="flex flex-col items-center h-fit">
      <div
      
        v-if="isConnected"
        class="w-12 rounded-full h-12 flex flex-col items-center justify-center border border-1 border-WHITE bg-LIGHTGREEN"
      >
        <font-awesome-icon size="xl" icon="fa-solid fa-check" />
      </div>
      <img v-else class="w-32" :src="imageUrl" />
      <div class="flex flex-col">
        <p class="text-md font-semibold pt-6">POW Want to Connect to {{ walletInfo.name }}</p>
        <p class="font-normal pt-3 text-xs text-GREY">
          {{ walletInfo.content }}
        </p>
      </div>
    </div>
    <div class="flex flex-col gap-6 pt-3 items-center w-full pb-3">
      <pow-button v-if="isConnected" secondary class="w-full" :loading="loading">
        <p>Connect Wallet</p>
      </pow-button>
      <pow-button v-else secondary class="w-full" :loading="loading">
        <p>Back to Swap Tokens</p>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import PowButton from '@/components/PowButton.vue'

import { ref } from 'vue'

const isConnected = ref(false)

const props = defineProps({
  walletInfo: {
    type: Object,
    required: true
  }
})
const loading = ref(false)
const imageUrl = new URL(`@/assets/icons/${props.walletInfo.icon}`, import.meta.url).href


</script>
